import { useEffect, useState } from "react";
import ModalComponent from "components/modal";
import { addBudgetType, deleteBudgetType } from "api/budget";
import { useSharedState } from "state";
import Table from "components/table";
import ActionButton from "components/table/action-btn";
import { oneLine } from "components/table/table-parts";
import { IconLock, IconLockOpen, IconPencil, IconTrash, IconX } from "@tabler/icons-react";
import { Budget, BudgetDefault } from "types/dict";
import DangerModal from "components/modal/danger";

export default function BudgetTypes() {
  const { budgetTypes, getBudgetTypesData, notify } = useSharedState();

  const [budgetTypeToChange, setBudgetTypeToChange] = useState<Budget>(BudgetDefault);
  const [isAddingBudgetType, setAddingBudgetType] = useState<boolean>(false);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const [newBudgetTypeName, setNewBudgetTypeName] = useState<string>("");

  const deleteBudgetDanger = "Вы действительно хотите удалить статью бюджета?";

  useEffect(() => {
    getBudgetTypesData();
  }, []);

  const openBudgetTypeModal = () => {
    const button = document.createElement("button");
    button.setAttribute("data-bs-toggle", "modal");
    button.setAttribute("data-bs-target", "#modal");
    document.body.appendChild(button);
    button.click();
    button.remove();
  };

  const cancelBudgetTypeCreation = () => {
    setNewBudgetTypeName("");
    setAddingBudgetType(false);
  };

  const onBudgetTypeDelete = async () => {
    openBudgetTypeModal();
    setFormLoading(true);

    try {
      await deleteBudgetType(budgetTypeToChange.budget_type_id);
      notify("Статья бюджета удалена", "success");

      getBudgetTypesData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при удалении статьи бюджета");
    } finally {
      setFormLoading(false);
    }
  };

  const createBudgetType = async () => {
    setFormLoading(true);

    try {
      await addBudgetType(newBudgetTypeName);
      notify("Статья бюджета добавлена", "success");

      cancelBudgetTypeCreation();
      getBudgetTypesData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при добавлении статьи бюджета");
    } finally {
      setFormLoading(false);
    }
  };

  const budgetTypesTableHeaders = [
    { header_text: "Название", narrow: false, wrap: false },
    { header_text: "Действия", narrow: false, wrap: false },
  ];

  const budgetTypesList = (
    <>
      {budgetTypes.map((budgetType, index) => (
        <tr key={index}>
          <td>{oneLine(budgetType.name)}</td>
          <td>
            <ActionButton
              icon={<IconTrash className="icon" />}
              title={"Удалить"}
              action={() => setBudgetTypeToChange(budgetType)}
              color={"danger"}
              modal={true}
              modal_id="#modal-delete-budget"
            />
          </td>
        </tr>
      ))}

      {isAddingBudgetType && (
        <tr>
          <td>
            <input
              type="text"
              className="form-control"
              placeholder="Название новой статьи"
              value={newBudgetTypeName}
              onChange={(e) => setNewBudgetTypeName(e.target.value.slice(0, 100))}
              disabled={isFormLoading}
            />
          </td>
          <td>
            <ActionButton
              icon={<IconX className="icon" />}
              title="Отмена"
              action={cancelBudgetTypeCreation}
              color="danger"
              modal={false}
            />
          </td>
        </tr>
      )}
    </>
  );

  const usersTable = Table(budgetTypesTableHeaders, budgetTypesList, false);

  const budgetTypesFooter = (
    <button
      className="btn btn-success d-flex gap-1"
      onClick={isAddingBudgetType ? createBudgetType : () => setAddingBudgetType(true)}
      disabled={isFormLoading || (isAddingBudgetType && !newBudgetTypeName?.length)}
    >
      {isAddingBudgetType ? "Сохранить" : "Добавить статью"}
      {isFormLoading && <div className="spinner-border spinner-border-sm" role="status" />}
    </button>
  );

  return (
    <>
      <ModalComponent
        header="Список статей бюджета"
        body={usersTable}
        footer={budgetTypesFooter}
        disableClose={isFormLoading}
      />
      <DangerModal
        modal_id="modal-delete-budget"
        dangerDescription={deleteBudgetDanger}
        cancel={openBudgetTypeModal}
        confirm={onBudgetTypeDelete}
      />
    </>
  );
}
